import { useState, type FormEvent } from "react";

export interface HatchPanelProps {
  onHatch(name: string): void;
}

/** docs/SPEC.md section 3: 1 to 12 letters or numbers. */
const MAX_NAME_LENGTH = 12;
const NAME_PATTERN = /^[\p{L}\p{N}]{1,12}$/u;

/**
 * Trims a raw pet name and returns it if it is 1 to 12 letters or numbers, otherwise null.
 */
export function sanitizeHatchName(raw: string): string | null {
  const trimmed = raw.trim();
  return NAME_PATTERN.test(trimmed) ? trimmed : null;
}

export function HatchPanel({ onHatch }: HatchPanelProps) {
  const [name, setName] = useState("");
  const validName = sanitizeHatchName(name);

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!validName) return;
    onHatch(validName);
  }

  return (
    <form className="hatch-panel" data-testid="hatch-panel" onSubmit={handleSubmit}>
      <label className="hatch-label" htmlFor="hatch-name-input">
        Pet name
      </label>
      <div className="fi hatch-controls">
        <input
          id="hatch-name-input"
          name="petName"
          type="text"
          className="hatch-input"
          data-testid="hatch-name-input"
          value={name}
          maxLength={MAX_NAME_LENGTH}
          required
          autoComplete="off"
          placeholder="Name (1-12)"
          aria-label="Pet name"
          onChange={(e) => setName(e.target.value)}
        />
        <button
          type="submit"
          className="btn hatch-button"
          data-testid="hatch-button"
          disabled={validName === null}
        >
          Hatch
        </button>
      </div>
    </form>
  );
}
